import { render, staticRenderFns } from "./YtVideo.vue?vue&type=template&id=35d4ce43&lang=pug&"
import script from "./YtVideo.vue?vue&type=script&lang=ts&"
export * from "./YtVideo.vue?vue&type=script&lang=ts&"
import style0 from "./YtVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports